import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer
} from "react";

export const AuthContext = createContext();

export const initialState = {
  accessToken: window.localStorage.getItem("accessToken"),
  sessionId: window.localStorage.getItem("sessionId"),
  roleConfig: JSON.parse(window.localStorage.getItem("roleConfig")),
  user: JSON.parse(window.localStorage.getItem("user")),
  primaryUser: window.localStorage.getItem("primaryUser"),
  location: window.localStorage.getItem("location")
};

export function authReducer(state, action) {
  switch (action.type) {
    case "onRoleSwitch":
    case "onRefresh":
    case "onLogin": {
      const { accessToken, refreshToken, role, primaryUser, location } =
        action.payload;
      window.localStorage.setItem("accessToken", accessToken);
      window.localStorage.setItem("sessionId", refreshToken);
      window.localStorage.setItem("roleConfig", JSON.stringify(role));
      window.localStorage.setItem("user", JSON.stringify(action.payload));
      window.localStorage.setItem("primaryUser", primaryUser);
      window.localStorage.setItem("location", location);
      return {
        ...state,
        accessToken,
        sessionId: refreshToken,
        roleConfig: role,
        user: action.payload,
        primaryUser
      };
    }
    case "onLogout": {
      window.localStorage.clear();
      return {
        accessToken: null,
        sessionId: null,
        roleConfig: null,
        user: null,
        primaryUser: null
      };
    }
    default:
      throw new Error("Invalid action type");
  }
}

export default function AuthContextProvider({ children }) {
  const [authConfig, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    global.authDispatch = dispatch;
  }, []);

  const parsedRoleConfig = useMemo(() => {
    if (authConfig.roleConfig) {
      const { features } = authConfig.roleConfig;

      const genericConfig = features.reduce((acc, feature) => {
        const permissions = feature.permissionTypes.map((type) => type.name);
        return { ...acc, [feature.name]: permissions };
      }, {});

      return genericConfig;
    }
    return null;
  }, [authConfig]);

  const authContext = useMemo(
    () => ({
      authConfig,
      parsedRoleConfig,
      dispatch
    }),
    [authConfig, parsedRoleConfig]
  );

  return (
    <AuthContext.Provider value={authContext}>{children}</AuthContext.Provider>
  );
}

export const useAuthContext = () => useContext(AuthContext);
